'use client';

import {useEffect, useState} from 'react';
import clsx from 'clsx';

import {graphQLClient} from '@/graphql/fetcher';
import {GET_CART_ITEMS_QUANTITY} from '@/graphql/queries';
import type {QueryResponse} from '@/graphql/types';

export const CartItems = () => {
	const [cartItems, setCartItems] = useState(0);

	useEffect(() => {
		const UID = localStorage.getItem('GAUS_VINDU_ID');
		const localCount = Number(localStorage.getItem('GAUS_VINDU_CART_ITEMS_COUNT')) || 0;
		setCartItems(localCount); // Immediately show local cached count

		async function getCartItems() {
			if (UID) {
				const data = await fetchCart(UID);
				if (data) {
					const itemCount = data?.totalItems;
					setCartItems(itemCount);
					localStorage.setItem('GAUS_VINDU_CART_ITEMS_COUNT', String(itemCount));
				}
			}
		}

		getCartItems();
	}, []);

	async function fetchCart(cartUID: string) {
		try {
			const data: QueryResponse = await graphQLClient.request(GET_CART_ITEMS_QUANTITY, {
				cartUID,
			});
			return data.cart;
		} catch (error) {
			console.error('Error fetching cart items:', error);
			return null;
		}
	}

	return (
		<span
			className={clsx(
				'bg-[#553232]',
				'absolute',
				'-top-1.5',
				'-right-1.5',
				'size-5',
				'rounded-full',
				'flex',
				'justify-center',
				'items-center',
				'font-bold',
				'text-[13px]',
			)}
		>
			{cartItems}
		</span>
	);
};
